<template>
  <div class="app-esim-manual-input content-width">
    <h3 class="text-3xl">Manuelle Eingabe</h3>
    <div class="mb-4">
        <p>
          Gib die Daten zum Einrichten selber ein. Wir stellen dir hier alles zur Verfügung.
        </p>
        <p>
          Hier findest du eine Erklärung für iOS und Android Geräte:<br />
          <a href="files/lidl/downloads/LIDL_Connect_eSIM_Anleitung_Manuell_iOS.pdf" target="_blank" rel="noopener">Anleitung für iOS</a><br />
          <a href="files/lidl/downloads/LIDL_Connect_eSIM_Anleitung_Manuell_Android.pdf" target="_blank" rel="noopener">Anleitung für Android</a>
        </p>
    </div>

    <div class="input-field">
        <label class="text-base-medium">SM-DP + Adresse:</label>
        <input type="text" class="input" :value="smdp" required readonly autocomplete="off"/>
        <button @click="copySmDp()" type="button" class="btn btn-primary copy-btn">
          <img src='/files/lidl/images/new-icons/svg/copy-outline.svg'>
        </button>
    </div>
    <div class="input-field">
      <label class="text-base-medium">Aktivierungscode:</label>
      <input type="text" class="input" :value="activationCode" required readonly autocomplete="off"/>
      <button @click="copyActivationCode()" type="button" class="btn btn-primary copy-btn">
        <img src='/files/lidl/images/new-icons/svg/copy-outline.svg'>
      </button>
    </div>
    <div class="input-field">
      <label class="text-base-medium">Bestätigungscode (ePIN):</label>
      <input class="input" :type="fieldType" :value="ePin" required readonly autocomplete="off" @input="() => false"/>
      <button @click="toggleEPin()" type="button" class="btn btn-primary copy-btn">
        <img v-if="!showEPin" src='/files/lidl/images/new-icons/svg/eye-outline.svg'>
        <img v-if="showEPin" src='/files/lidl/images/new-icons/svg/eye-slash.svg'>
      </button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'ESimManualInput',
  props: {
    smdp: {
      type: String,
      default: ''
    },
    activationCode: {
      type: String,
      default: ''
    },
    ePin: {
      type: String,
      default: ''
    }
  },
  components: {},
  data() {
    return {
      fieldType: 'password',
      showEPin: false
    }
  },
  computed: {},
  methods: {
    copySmDp() {
      navigator.clipboard.writeText(this.smdp)
    },
    copyActivationCode() {
      navigator.clipboard.writeText(this.activationCode)
    },
    toggleEPin() {
      this.showEPin = !this.showEPin

      if (this.showEPin) {
        this.fieldType = 'text'
      } else this.fieldType = 'password'
    }
  },
  mixins: [],
  apollo: {}
}
</script>
